import { StylesConfig } from 'react-select';
import { theme } from '../../../tailwind.theme';

// List of elements: https://react-select.com/styles

export const customStyles: StylesConfig = {
  container: (provided) => ({
    ...provided,
    cursor: 'pointer'
  }),
  control: (provided) => ({
    ...provided,
    cursor: 'pointer',
    border: `1px solid ${theme.colors.neutral['300']}`,
    boxShadow: 'none',
    borderRadius: '8px',
    '&:hover': {
      border: `1px solid ${theme.colors.neutral['400']}`
    },
    '&:focus': {
      border: `1px solid ${theme.colors.neutral['400']}`
    }
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    cursor: 'pointer',
    borderRadius: '8px',
    zIndex: 9999,
    color: theme.colors.neutral['800']
  }),
  option: (provided, { isSelected }) => {
    return {
      ...provided,
      backgroundColor: isSelected ? theme.colors.neutral['100'] : '#fff',
      color: theme.colors.neutral['800'],
      fontWeight: 400,
      fontFamily: 'Open Sans',
      cursor: 'pointer',
      lineHeight: '24px',
      padding: '10px 16px',
      '&:hover': {
        backgroundColor: theme.colors.neutral['100']
      }
    };
  },
  valueContainer: (provided) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    padding: '4px 6px',
    color: theme.colors.neutral['800']
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    height: '20px',
    padding: '0 6px',
    fontFamily: 'Open Sans'
  }),
  menuList: (provided) => ({
    ...provided,
    borderRadius: '8px',
    '::-webkit-scrollbar': {
      width: '4px',
      height: '0px'
    },
    '::-webkit-scrollbar-track': {
      display: 'none'
    },
    '::-webkit-scrollbar-thumb': {
      background: '#888'
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555'
    }
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    fontFamily: 'Open Sans',
    color: theme.colors.neutral['400']
  }),
  indicatorsContainer: (base) => ({
    ...base,
    color: theme.colors.neutral['300']
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: theme.colors.neutral['300']
  }),
  clearIndicator: (base) => ({
    ...base,
    color: theme.colors.neutral['300']
  }),
  multiValue: (base) => ({
    ...base,
    background: theme.colors.primary['100'],
    color: theme.colors.neutral['800'],
    borderRadius: '8px',
    padding: '2px 8pxpx',
    margin: '0 2px'
  })
};
